import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Accordion } from '@appcues/sonar';
import { FieldSet, Label } from 'ext/components/ui';
import { StyleShape } from 'entities/step-children/shape';
import { selectUserPreferences } from 'entities/user-preferences/reducer';
import { COLOR_MODES } from 'lib/user-preferences';
import ColorInput from 'components/ColorInput';
import InputWithValidation from 'components/InputWithValidation';
import {
  Controls,
  GroupedField,
  GroupedFieldSet,
} from 'components/SideBarSettings/Shared/styled';
import useStyleSettings from 'components/SideBarSettings/Shared/use-style-settings';
import useAccordionClick from 'components/SideBarSettings/Shared/use-accordion-click';

function BoxStyle({ style, onChange, colorMode }) {
  const trackAccordion = useAccordionClick();

  const handleChange = useCallback(
    patch => onChange({ style: patch }),
    [onChange]
  );

  const [valueFor, handleChangeFor] = useStyleSettings({
    onChange: handleChange,
    style,
    colorMode,
  });

  return (
    <Accordion.Item value="style">
      <Accordion.Header>
        <Accordion.Trigger
          onClick={() => trackAccordion('TextField', 'Box style')}
        >
          Box style
        </Accordion.Trigger>
      </Accordion.Header>
      <Accordion.Content>
        <Controls>
          <FieldSet>
            <Label htmlFor="text-field-background">Background color</Label>
            <ColorInput
              id="text-field-background"
              color={valueFor.backgroundColor}
              onChange={handleChangeFor.backgroundColor}
            />
          </FieldSet>

          <GroupedFieldSet>
            <GroupedField>
              <Label htmlFor="text-field-border-color">Border color</Label>
              <ColorInput
                id="text-field-border-color"
                color={valueFor.borderColor}
                onChange={handleChangeFor.borderColor}
              />
            </GroupedField>

            <GroupedField>
              <Label htmlFor="text-field-thickness">Thickness</Label>
              <InputWithValidation
                id="text-field-thickness"
                key={valueFor.borderWidth}
                defaultValue={valueFor.borderWidth}
                onChange={handleChangeFor.borderWidth}
                type="number"
                placeholder="0"
                min="0"
              />
            </GroupedField>
          </GroupedFieldSet>

          <FieldSet>
            <InputWithValidation
              label="Corner radius"
              value={valueFor.cornerRadius}
              onChange={handleChangeFor.cornerRadius}
              max={100}
              min={0}
              range
            />
          </FieldSet>
        </Controls>
      </Accordion.Content>
    </Accordion.Item>
  );
}

BoxStyle.propTypes = {
  style: StyleShape,
  onChange: PropTypes.func,
  colorMode: PropTypes.oneOf(COLOR_MODES),
};

const mapStateToProps = state => ({
  colorMode: selectUserPreferences(state).colorMode,
});

export default connect(mapStateToProps)(BoxStyle);
